import { z } from 'zod';

import type { TranslationKey } from '@/i18n-key';
import type { User } from '@/types/directory/User';

export const DefineAudienceFormFields = {
    computedEmployees: 'computedEmployees',
} as const;

const VALIDATION_ERROR_NO_AUDIENCE: TranslationKey =
    'cycleEvaluationDefineAudience.validation.noAudience';

export const defineAudienceSchema = z.object({
    computedEmployees: z
        .custom<User[]>((value) => Array.isArray(value))
        .refine((audience) => audience.length > 0, {
            message: VALIDATION_ERROR_NO_AUDIENCE,
        }),
});

export type DefineAudienceFormData = z.infer<typeof defineAudienceSchema>;
